// extracted by mini-css-extract-plugin
export default {"wrapper":"RoleFilter_wrapper__3wIgh"};